<template>
  <li class="tp-show__list-item tp-allshow__list-item">
    <router-link :to="'/' + lang + '/' + typeSlug + '/' + channelSlug +'/' + projectSlug">
      <div class="tp-show__list-item__thumb tp-show__list-item__thumb_large">
        <img v-lazy="$store.state.imgDomain + image" alt="">
      </div>
      <div class="tp-show__list-item__desc tp-allshow__list-item__desc">
        <h2>{{ name }}</h2>
      </div>
    </router-link>
  </li>
</template>

<script>

export default {
  name: "showElement",
  props: ['title',
          'image',
          'channelSlug',
          'name',
          'projectSlug',
          'typeSlug',
          'typeSlugTitle',
          'lang',
          'seoTitle',
          'seoDescription',
          'seoKeywords'
  ],
  data() {
    return {
      loading: true,
      compHidden: true,

    };
  },
}
</script>

<style scoped>

</style>

